<nb-card class="lista-crud">
  <nb-card-header class="head">
    <div class="titulo-bloco">
      <span class="titulo-principal">Integrações com o Theos</span>
      <span class="titulo-contexto">
        As mesmas rotinas que rodam por agendamento no servidor. Use para forçar uma atualização
        agora, sem esperar o cron.
      </span>
    </div>

    <div class="acoes-topo">
      <button nbButton status="basic" size="medium" type="button" (click)="carregar()" [disabled]="carregando">
        <nb-icon pack="eva" icon="refresh-outline"></nb-icon>
        <span>Atualizar</span>
      </button>
      <button
        nbButton
        status="primary"
        size="medium"
        type="button"
        [disabled]="!rotinas.length || disparandoTodas || !!disparando"
        [nbSpinner]="disparandoTodas"
        (click)="executarTodas()"
      >
        <nb-icon pack="eva" icon="flash-outline"></nb-icon>
        <span>Executar todas</span>
      </button>
    </div>
  </nb-card-header>

  <nb-card-body>
    <div class="carregando-lista" *ngIf="carregando">
      <nb-spinner status="primary" size="medium"></nb-spinner>
      <span>Carregando rotinas…</span>
    </div>

    <p class="vazio erro" *ngIf="erro">{{ erro }}</p>

    <p class="aviso-execucao" *ngIf="algumaEmExecucao">
      <nb-icon pack="eva" icon="sync-outline"></nb-icon>
      Há rotina em execução — esta lista se atualiza sozinha a cada 5 segundos.
    </p>

    <div class="rotinas" *ngIf="!carregando && !erro && rotinas.length">
      <article class="rotina" *ngFor="let r of rotinas; trackBy: trackByCodigo" [class.rodando]="r.emExecucao">
        <header class="rotina-cabecalho">
          <h3 class="rotina-nome">{{ r.nome }}</h3>
          <span class="tag-rodando" *ngIf="r.emExecucao">
            <nb-spinner size="tiny" status="info"></nb-spinner>
            em execução
          </span>
        </header>

        <p class="rotina-descricao">{{ r.descricao }}</p>

        <p class="rotina-ultima">
          <ng-container *ngIf="dataHoraUltima(r) as dt; else semExecucao">
            <span class="rotulo">Última execução</span>
            <span class="valor">{{ dt | date: 'dd/MM/yyyy HH:mm' }}</span>
            <span class="registros" *ngIf="r.ultimaExecucao?.qtdRegistros != null">
              · {{ r.ultimaExecucao?.qtdRegistros }} registro(s)
            </span>
            <span class="tag-erro" *ngIf="r.ultimaExecucao?.erro" [title]="r.ultimaExecucao?.mensagemErro || 'Erro'">
              terminou com erro
            </span>
          </ng-container>
          <ng-template #semExecucao>
            <span class="rotulo">Última execução</span>
            <span class="valor sem">nunca executada</span>
          </ng-template>
        </p>

        <p class="rotina-erro" *ngIf="r.ultimaExecucao?.erro && r.ultimaExecucao?.mensagemErro">
          {{ r.ultimaExecucao?.mensagemErro }}
        </p>

        <footer class="rotina-acoes">
          <button
            nbButton
            status="info"
            size="small"
            type="button"
            [disabled]="r.emExecucao || disparando === r.codigo || disparandoTodas"
            [nbSpinner]="disparando === r.codigo"
            (click)="executar(r)"
          >
            <nb-icon pack="eva" icon="play-circle-outline"></nb-icon>
            <span>{{ r.emExecucao ? 'Em execução' : 'Executar' }}</span>
          </button>
          <code class="rotina-codigo" [title]="'Código da rotina na API'">{{ r.codigo }}</code>
        </footer>
      </article>
    </div>

    <p class="vazio" *ngIf="!carregando && !erro && !rotinas.length">
      Nenhuma rotina de integração disponível na API.
    </p>
  </nb-card-body>
</nb-card>
